// extracted by mini-css-extract-plugin
module.exports = {"faqBannerMain":"faq-page-banner_faqBannerMain__CDZjr","titleTextContainer":"faq-page-banner_titleTextContainer__nTcc4"};